import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import formSlice from 'components/Form/formSlice';
import homeSlice from 'features/home/homeSlice';
import socketSlice from 'features/socket/socketSlice';
import chatSlice from 'redux/chatSlice';
import platformSlice from 'redux/platformSlice';
import teaserSlice from 'redux/teaserSlice';
import userSlice from 'redux/userSlice';
import casinoSlice from 'redux/casinoSlice';
import gameSlice from 'redux/gameSlice';

export const store = configureStore({
  reducer: {
    platform: platformSlice,
    socket: socketSlice,
    form: formSlice,
    home: homeSlice,
    user: userSlice,
    chat: chatSlice,
    teaser: teaserSlice,
    casino: casinoSlice,
    game: gameSlice,
  },
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
